import { useT } from '../../i18n';
import { initials } from '../../lib/patient';

export function SurakshaMark({ className = 'h-10 w-10' }: { className?: string }) {
  return (
    <svg viewBox="0 0 48 48" className={className} aria-hidden="true">
      <path d="M24 3l17 6v13c0 11-7.5 19.5-17 23C14.5 41.5 7 33 7 22V9z" fill="#005F60" />
      <path d="M17 21a10 10 0 0 1 14 0M20 25a5.5 5.5 0 0 1 8 0" stroke="#FBBF24" strokeWidth="2.6" strokeLinecap="round" fill="none" />
      <circle cx="24" cy="30" r="2.6" fill="#FBBF24" />
    </svg>
  );
}

export function ClinicLogo({ src, alt, className = 'h-10 w-10' }: { src: string; alt: string; className?: string }) {
  if (!src) {
    return (
      <span className={`${className} flex shrink-0 items-center justify-center rounded-xl bg-brand text-sm font-bold text-white`} data-testid="clinic-logo">
        {initials(alt || 'C')}
      </span>
    );
  }
  return <img src={src} alt={alt} className={`${className} shrink-0 rounded-xl object-contain`} data-testid="clinic-logo" />;
}

export function PoweredBy({ light = false }: { light?: boolean }) {
  const t = useT();
  return (
    <p data-testid="powered-by" className={`flex items-center gap-1.5 text-xs ${light ? 'text-teal-100/70' : 'text-slate-500'}`}>
      <SurakshaMark className="h-4 w-4" />
      {t('app.poweredBy')}
    </p>
  );
}
